/**
 * DataError
 */
class DataError extends Error {
  constructor (message) {
    super(message)
  }
}

/**
 * Export
 */
module.exports = DataError
